module.exports = __webpack_public_path__ + "static/media/Upcoming-graduates-illustration.155ea8dc.svg";